import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withNamespaces} from 'react-i18next';
// import moment from "moment";
import SMSListing from "./SMSListing";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { getList } from '../../store/ducks/sms/actions';
import { filterErrorHandler } from '../../hoc/Shared/utility';
// import Select from "../../components/Input/Select/Select";

const initialInputState =
{
    /* form input value */
    filter_date: "",
    contact_number: '',
    otp_code: '',
    username: '',
    type: ''
};

let smsData = {};
class SMS extends Component {
    constructor(props) {
        super(props);

        this.state = {
            pageShow: (this.props.location.state === undefined) ? "listing" : this.props.location.state.pageShow,
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            sorted: null,
            totalRecords: 0,
            loading: true,
            data: [],
            dropDown: [],
            filter: initialInputState,
            isOpen: false,
            currentAdminId: '',
            permission: []
        }
    }

    fetchData() {
        let availablePage = this.state.activePage;
        if (this.state.totalRecords !== 0) {
            availablePage = parseInt((this.state.totalRecords / this.state.limit) + 1);
            (this.state.activePage >= availablePage) && this.setState({ activePage: availablePage});
        }

        Object.keys(this.state.filter).forEach((val) =>
        {
            // listingArr[val] = this.state.filter[val];
            // adminData[val] = ((val==='start_date' || val==='end_date') && this.state.filter[val]!=='') ? moment(this.state.filter[val]).format("YYYY-MM-DD HH:mm:ss") : this.state.filter[val];
        });

        smsData.page = (this.state.activePage >= availablePage) ? availablePage : this.state.activePage;
        smsData.limit = this.state.limit;
        smsData.order = JSON.stringify(this.state.sorted);
        smsData.lang_id = this.props.currentLanguageId;
        smsData.country_id = this.props.currentCountryId;
        smsData.contact_number = this.state.filter.contact_number;
        smsData.otp_code = this.state.filter.otp_code;
        smsData.username = this.state.filter.username;
        smsData.type = this.state.filter.type;
        smsData.filter_date = this.state.filter.filter_date;
        this.props.getList(smsData);
    }

    componentDidMount() {
        if(this.state.pageShow!=='show')
        {
            this.fetchData();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.permission.length === 0 && this.props.currentPermission !== undefined) {
            // let adminPermission = this.props.currentPermission.filter((item) => item.includes("admin_"));
            this.setState({permission: this.props.currentPermission});
        }

        if (nextProps.sms_otp_data !== this.props.sms_otp_data && nextProps.sms_otp_data !== undefined) {
            if (nextProps.sms_otp_data.responseCode === 200 && nextProps.sms_otp_data.msgType === 'success') {            
                this.setState({
                    loading: false,
                    data: nextProps.sms_otp_data.data.row,
                    totalRecords: nextProps.sms_otp_data.data.pagination.total_record
                })
            } else {
                this.setState({
                    loading: false,
                    data: [],
                    totalRecords: 0,
                    activePage: 1,
                }, () => {
                    filterErrorHandler(nextProps.sms_otp_data.message);
                });
            }
        }
        return true;
    }

    onInputChange(event)
    {
        const { id, value } = event.target;
        let newFilter = { ...this.state.filter, [id]: value };

        if (event.target.id === 'filter_date')
        {
            const date = (event.target.value!=='') ? event.target.value.split(" - ") : null;
            newFilter['start_date'] = (date) ? date[0] : '';
            newFilter['end_date'] = (date) ? date[1] : '';
        }

        this.setState({ filter: newFilter }, () => {
            if (id === 'type') {
                this.setState({ loading: true, data: [], activePage: 1 }, () => {
                    this.fetchData();
                });
            }
        });
    }

    refreshHandler = () => 
    {
        this.setState({
            loading: true,
            data: [],
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            sorted: null
        }, ()=>
        {
            this.fetchData();
        });
    }

    clearHandler = () => 
    {
        this.setState({
            activePage: 1,
            filter: initialInputState,
            loading: true,
            data: []
        }, ()=>
        
        {
            this.fetchData();
        });
    }

    changePageHandler = (page, Id) => {
        this.setState({
            pageShow: page,
            currentAdminId: Id
        });
    }

    pageChangeHandler = (activePage) => {
        this.setState({page: activePage, activePage: activePage, loading: true, data: []}, () => {
            this.fetchData();
        });
    }

    sizePerPageHandler = (limit) => {
        this.setState({limit: limit, loading: true, data: []}, () => {
            this.fetchData();
        });
    }

    postSearchHandler = () => {
        this.setState({ loading: true, data: [], activePage: 1 }, () => {
            this.fetchData();
        });
    }

    onSearchKeyPressHandler = (event) => {
        //Checking press the enter only perform search action
        if (event.key === "Enter") {
            this.setState({ loading: true, data: [], activePage: 1 }, () => {
                this.fetchData();
            });
        }
    }

    noFormatter = (cell, row, rowIndex) => {
        //let rowNumber = (this.state.activePage - 1) * this.state.limit + (rowIndex + 1);
        let rowNumber = (this.state.totalRecords - rowIndex - ((this.state.activePage - 1) * this.state.limit))
        return <span>{rowNumber}</span>;
    };

    render() {
        const {t} = this.props;
        let rsListing = [];
        let columns = [];

        columns = [
            {
                text: t('global.no'),
                dataField: "",
                keyField: "no",
                formatter: this.noFormatter,
                headerStyle: () => {
                    return { width: '60px' };
                }
            },
            {
                text: t('sms.type'),
                keyField: "type",
                dataField: "type"
            },
            {
                text: t('sms.create-date'),
                keyField: "created_at",
                dataField: "created_at"
            },
            {
                text: t('sms.contact-number'),
                keyField: "contact_number",
                dataField: "contact_number"
            },
            {
                text: t('sms.otp-code'),
                keyField: "otp_code",
                dataField: "otp_code"
            },
            {
                text: t('sms.status'),
                dataField: "status",
                keyField: "status",
                formatter: (cell, row) => {
                    const className = cell === 1 ? 'success' : 'danger';
                    return <span className={`badge badge-${className}`} >
                        {cell === 1 ? t('global.active') : t('global.inactive')}
                    </span>
                }
            },
            {
                text: t('sms.used'),
                dataField: "used",
                keyField: "used",
                formatter: (cell, row) => {
                    const className = cell === 1 ? 'success' : 'danger';
                    return <span className={`badge badge-${className}`} >
                        {cell === 1 ? t('global._yes') : t('global._no')}
                    </span>
                }
            },
            {
                text: t('sms.expiry-date'),
                dataField: "expiry_date",
                keyField: "created_at"
            }
        ];

        if (this.state.filter.type === "user_verification") {
            columns.splice(3, 0, {
                text: t('sms.username'),
                keyField: "username",
                dataField: "username"
            });
        } 
  
        if (this.state.data.length > 0) {
            rsListing = this.state.data.map((val, idx) => {
                let rowData = {
                    no: idx + 1,
                    type: t(`sms.${val.type}`),
                    created_at: val.created_at,
                    contact_number: val.contact_number,
                    otp_code: val.otp_code,
                    status: val.status,
                    used: val.used,
                    expiry_date: val.expiry_date
                };
    
                if (this.state.filter.type === "user_verification") {
                    rowData.username = val.username;
                }
    
                return rowData;
            });
        }
    
        return (            
            <Auxiliary>
                {this.state.pageShow === 'listing' &&
                <div>
                    <div className="breadcrumb-header">
                        <div className="my-auto">
                            <div className="d-flex">
                                <h4 className="text-muted mt-1 tx-13 ml-2 mb-0">{t('sms.title')}</h4>
                            </div>
                        </div>
                    </div>
                    <SMSListing
                        filter_date={this.state.filter.filter_date}
                        username={this.state.filter.username}
                        contact_number={this.state.filter.contact_number}
                        otp_code={this.state.filter.otp_code}
                        type={this.state.filter.type}
                        onInputChange={(event) => this.onInputChange(event)}
                        clearHandler={() => this.clearHandler()}
                        refreshHandler={() => this.refreshHandler()}
                        columns={columns}
                        activePage={this.state.activePage}
                        limit={this.state.limit}
                        totalRecords={this.state.totalRecords}
                        data={rsListing}
                        order={this.state.sorted}
                        pageChangeHandler={this.pageChangeHandler}
                        sizePerPageHandler={this.sizePerPageHandler}
                        postSearchHandler={this.postSearchHandler}
                        searchPressSubmitHandler={(event) => this.onSearchKeyPressHandler(event)}
                        loading={this.state.loading}
                        permission={this.state.permission}

                        /**filter drop down*/
                        changePageHandler={this.changePageHandler}
                    />
                </div>
                }
            </Auxiliary>
        )
    }
};

//Received the response from the redux calling the api response
const mapStateToProps = state => {
    const {smsOtp,currentUser} = state;

    return {
        sms_otp_data: smsOtp.rs,
        currentPermission: currentUser.data.permission,
        currentCountryId: currentUser.data.country_id,
        currentLanguageId: currentUser.data.language_id,
    }
};

const mapDispatchToProps = {
    getList
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces('translation')(SMS));